import { styled, useTheme } from '@mui/material';

import { SxProps } from '../../../types';

export type IndicatorProps = {
  size?: 'large' | 'medium' | 'small' | 'dot';
  color?: 'blue' | 'ocean' | 'indigo' | 'grey' | 'red';
  count?: number;
  sx?: SxProps;
  testId?: string;
};

const IndicatorRoot = styled('div', {
  name: 'DsIndicator',
  slot: 'Root',
  target: 'DsIndicator-root',
  overridesResolver: (props, styles) => [
    styles.root,
    styles[props.color],
    styles[props.size],
  ],
  shouldForwardProp: (propName) =>
    !(['size', 'color', 'count', 'sx'] as PropertyKey[]).includes(propName),
})<IndicatorProps>({});

const IndicatorLabel = styled('span', {
  name: 'DsIndicator',
  slot: 'Label',
  target: 'DsIndicator-label',
  overridesResolver: (_, styles) => [styles.label],
})({});

export const Indicator = ({ testId, ...props }: IndicatorProps) => {
  const theme = useTheme();
  return (
    <IndicatorRoot
      {...(theme.components?.DsIndicator?.defaultProps ?? {})}
      {...props}
      data-testid={testId}
    >
      <IndicatorLabel>{props.count}</IndicatorLabel>
    </IndicatorRoot>
  );
};
